export const fontImportUrl =
    "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap";

export const fontFamilies = {
    inter: "'Inter', sans-serif",
};

export const fontWeights = {
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
};

export const fontSizes = {
    xSmall: "0.75rem", // 12px
    small: "0.875rem", // 14px
    medium: "1rem", // 16px
    large: "1.125rem", // 18px
    xLarge: "1.25rem", // 20px
    xxLarge: "1.5rem", // 24px
    xxLargePlus: "1.75rem", // 28px
    xxxLarge: "2rem", // 32px
    xxxLargePlus: "2.125rem", // 34px
    huge: "2.625rem", // 42px,
    extraHuge: "3.5rem", //56px
};

export const lineHeights = {
    default: "120%",
    defaultLarge: "150%",
    defaultMedium: "130%",
    xSmall: "1.125rem", // 18px → 1.5 × 12px
    small: "1.3125rem", // 20px → 1.5 × 14px
    medium: "1.5rem", // 24px → 1.5 × 16px
    large: "1.6875rem", // 28px → 1.5 × 18px
    xLarge: "1.875rem", // 30px → 1.5 × 20px
    xxLarge: "2.25rem", // 36px → 1.5 × 24px
    xxLargePlus: "2.625rem", // 42px → 1.5 × 28px
    xxxLarge: "3rem", // 48px → 1.5 × 32px
    xxxLargePlus: "3.1875rem", // 51px → 1.5 × 34px
    huge: "3.9375rem", // 63px → 1.5 × 42px
};

export const headings = {
    h1: {
        fontSize: "2.625rem", // 42px
        fontSizeSmall: fontSizes.xxxLargePlus,
        lineHeightSmall: "2.55rem",
        lineHeight: "3.15rem", // 50.4px
        fontWeight: 400,
    },
    h2: {
        fontSize: "2rem", // 32px
        fontSizeSmall: fontSizes.xxLargePlus,
        lineHeightSmall: "2.1rem",
        lineHeight: "2.4rem", // 38.4px
        fontWeight: 400,
    },
    h3: {
        fontSize: "1.5rem", // 24px
        fontSizeSmall: fontSizes.xLarge,
        lineHeightSmall: "1.5rem",
        lineHeight: "1.8rem", // 28.8px
        fontWeight: 600,
    },
    h4: {
        fontSize: "1.25rem", // 20px
        fontSizeSmall: fontSizes.large,
        lineHeightSmall: "1.35rem",
        lineHeight: "1.5rem", // 24px
        fontWeight: 600,
    },
    h5: {
        fontSize: "1.125rem", // 18px
        fontSizeSmall: fontSizes.small,
        lineHeightSmall: "1.05rem",
        lineHeight: "1.2rem", // 19.2px
        fontWeight: 600,
    },
};
